export default __webpack_public_path__ + "static/media/valley_water.a162fd05.png";